import { render, staticRenderFns } from "./WaMessageAdd.vue?vue&type=template&id=af7f6dc2&scoped=true&"
import script from "./WaMessageAdd.vue?vue&type=script&lang=js&"
export * from "./WaMessageAdd.vue?vue&type=script&lang=js&"
import style0 from "./WaMessageAdd.vue?vue&type=style&index=0&id=af7f6dc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7f6dc2",
  null
  
)

export default component.exports